import { AVIS_INICIALITZAR, AVIS_VISUALITZACIO_MODIFICAR_TEXT_NOU_COMENTARI } from '../../../../actions/actionTypes';

const ESTAT_INICIAL = '';

const textNouComentari = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_VISUALITZACIO_MODIFICAR_TEXT_NOU_COMENTARI:
            return action.text;

        default:
            return state;
    }
};

export default textNouComentari;



// WEBPACK FOOTER //
// ./src/reducers/avis/visualitzacio/comentaris/textNouComentari.js